const BASE = (process.env.REACT_APP_API_URL || 'http://localhost:5000/api').replace('/api', '');

export const imgUrl = (src) => {
  if (!src) return '';
  if (src.startsWith('http')) return src;  // already absolute (Unsplash fallbacks, etc.)
  return `${BASE}${src}`;
};
